import { render } from "./PostsComponent.vue?vue&type=template&id=10704c4d"
import script from "./PostsComponent.vue?vue&type=script&lang=js"
export * from "./PostsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__